export default {
      id: "icon-arrow-bottom-2-usage",
      viewBox: "0 0 32.529 17.706",
      url: __webpack_public_path__ + "assets/template/sprite/sprite.svg#icon-arrow-bottom-2",
      toString: function () {
        return this.url;
      }
    }